import React, { useState} from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import ZaposleniUnos from './ZaposleniTabs/ZaposleniUnos';
import ZaposleniPregled from './ZaposleniTabs/ZaposleniPregled';
import ZaposleniDokumentiGO from './ZaposleniTabs/ZaposleniDokumentiGO';
import ZaposleniAETRPotvrda from './ZaposleniTabs/ZaposleniAETRPotvrda';
import TransferZaposlenih from './ZaposleniTabs/TransferZaposlenih';
import RadniOdnos from './ZaposleniTabs/RadniOdnos';

const ZaposleniHome = () => {
  const { t } = useTranslation();

    const [changeView, setChangeView] = useState(1);
    const activeClass = 'activeButton'

return (
    <div style={{marginTop:'1%'}}>
        <Button id={changeView == 1 && activeClass} label={t('fakture.pregled')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(1)} } />
        <Button id={changeView == 2 && activeClass} label={t('admin.unos')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(2)} } />
        <Button id={changeView == 3 && activeClass}label={t('admin.dokumentiGo')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(3)} } />
        <Button id={changeView == 4 && activeClass}label={t('admin.aetrPotvrda')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(4)} } />
        <Button id={changeView == 5 && activeClass}label={t('transfer.tab')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(5)} } />
        <Button id={changeView == 6 && activeClass}label={t('radniOdnos.tab')} className="mt-3 zaposleniShift adminTab" onClick={()=> {setChangeView(6)} } />
        {changeView == 1 &&  <ZaposleniPregled/>}
        {changeView == 2 && <ZaposleniUnos/>}
        {changeView == 3 && <ZaposleniDokumentiGO/>}
        {changeView == 4 && <ZaposleniAETRPotvrda/>}
        {changeView == 5 && <TransferZaposlenih/>}
        {changeView == 6 && <RadniOdnos/>}
    </div>
)
}

export default ZaposleniHome;